/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserImageRatings = /* GraphQL */ `
  query GetUserImageRatings($s3_img_path: ID!) {
    getUserImageRatings(s3_img_path: $s3_img_path) {
      s3_img_path
      user_id
      rating_overall
      rating_canopy
      rating_vine
      rating_fruit
      user {
        user_id
        group_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        clientOrgInfoUsersGroup_id
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userInfoRatingsUser_id
      __typename
    }
  }
`;
export const listUserImageRatings = /* GraphQL */ `
  query ListUserImageRatings(
    $s3_img_path: ID
    $filter: ModelUserImageRatingsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserImageRatings(
      s3_img_path: $s3_img_path
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        s3_img_path
        user_id
        rating_overall
        rating_canopy
        rating_vine
        rating_fruit
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userInfoRatingsUser_id
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUserImageRatings = /* GraphQL */ `
  query SyncUserImageRatings(
    $filter: ModelUserImageRatingsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserImageRatings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        s3_img_path
        user_id
        rating_overall
        rating_canopy
        rating_vine
        rating_fruit
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userInfoRatingsUser_id
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const userImageRatingsByUser_idAndS3_img_path = /* GraphQL */ `
  query UserImageRatingsByUser_idAndS3_img_path(
    $user_id: ID!
    $s3_img_path: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserImageRatingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userImageRatingsByUser_idAndS3_img_path(
      user_id: $user_id
      s3_img_path: $s3_img_path
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        s3_img_path
        user_id
        rating_overall
        rating_canopy
        rating_vine
        rating_fruit
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userInfoRatingsUser_id
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getClientOrgInfo = /* GraphQL */ `
  query GetClientOrgInfo($group_id: ID!) {
    getClientOrgInfo(group_id: $group_id) {
      group_id
      is_vmc
      is_multi_vineyard
      users {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listClientOrgInfos = /* GraphQL */ `
  query ListClientOrgInfos(
    $group_id: ID
    $filter: ModelClientOrgInfoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listClientOrgInfos(
      group_id: $group_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        group_id
        is_vmc
        is_multi_vineyard
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncClientOrgInfos = /* GraphQL */ `
  query SyncClientOrgInfos(
    $filter: ModelClientOrgInfoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncClientOrgInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        group_id
        is_vmc
        is_multi_vineyard
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($user_id: ID!) {
    getUserInfo(user_id: $user_id) {
      user_id
      group_id
      group {
        group_id
        is_vmc
        is_multi_vineyard
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ratings {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      clientOrgInfoUsersGroup_id
      __typename
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos(
    $user_id: ID
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserInfos(
      user_id: $user_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        user_id
        group_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        clientOrgInfoUsersGroup_id
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUserInfos = /* GraphQL */ `
  query SyncUserInfos(
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        user_id
        group_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        clientOrgInfoUsersGroup_id
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const userInfosByGroup_idAndUser_id = /* GraphQL */ `
  query UserInfosByGroup_idAndUser_id(
    $group_id: ID!
    $user_id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userInfosByGroup_idAndUser_id(
      group_id: $group_id
      user_id: $user_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        user_id
        group_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        clientOrgInfoUsersGroup_id
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
